<template>
  <div ref="photo_body" class="body" @click="switchMode()">
    <transition name="fade">
      <img id="slide0" ref="slide0" class="img noShow shadow-lg slideshow_img" :class="{'selectAlbumBackground': current_view == views['ALBUMS'], 'visible': current_view == views['ALBUMS'] && currentImgElem == 0, 'fastTransition': current_view == views['ALBUMS']}">
    </transition>
    <transition name="fade">
      <img id="slide1" ref="slide1" class="img noShow shadow-lg slideshow_img" :class="{'selectAlbumBackground': current_view == views['ALBUMS'], 'visible': current_view == views['ALBUMS'] && currentImgElem == 1, 'fastTransition': current_view == views['ALBUMS']}">
    </transition>

    <div class='clickhelper_container'>
      <div v-if="current_view == views['SLIDESHOW']" ref="clickhelper" class="clickhelper noOpacity">click to view albums</div>
    </div>

    <transition name="fade2">
      <div id="albums_container" ref="albums_container" v-if="current_view == views['ALBUMS']" @mouseleave="hideCoverPhoto()">
        <div class="category" v-for="(albums, category) in category_albums" :key="category">
            <div class="categoryTxt" @click="noPropogation($event)">{{category}}</div>
            <ul class="albums_list">
              <li v-for="album in albums" :key="album.title" @mouseenter="showCoverPhotoDebounce($event, album.id)" @mouseleave="darkenCoverPhoto($event, album.id)"><a :href="'https://photography.gproductions.org/' + album.id" target="_blank" @click="noPropogation($event)">{{album.title}}</a></li>
            </ul>
        </div>
      </div>
    </transition>

    <!-- <transition name="fade">
      <div v-if="current_view == views['SLIDESHOW']" id="collectionBtn" ref="collectionBtn" class="gnCollection" @click="switchToSelectAlbumMode()">
        <svg id="collectionSVG" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.44 1.999l-.439-1.999h17.994l-.439 1.999h-17.116zm-3.44 6.001l2.035 16h19.868l2.097-16h-24zm22.255-2l.371-2h-21.256l.371 2h20.514z"/></svg>
        <div id="collectionText">ALBUMS</div>
      </div>
    </transition> -->

    

    <transition name="fade">
      <div v-if="current_view == views['ALBUMS']" id="returnBtn" ref="returnBtn" class="gnCollection" @click="switchToHome($event)">
        <svg id="returnBtnSVG" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
        <!-- <svg id="returnBtnSVG" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg> -->
        <!-- <div id="returnBtnText">BACK</div> -->
      </div>
    </transition>
    

    <transition name="slide-fade">
      <div v-if="current_view == views['SLIDESHOW'] && comment != ''" id="comment" ref="comment">{{comment}}</div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */

import $ from 'jquery'

export default {
  name: 'PHOTOGRAPHY',
  props: {
    pageMessages: Object,
    thisPage: Number,
    isMobile: Boolean
  },

  data() {
    return {
      publicAlbums: [],
      privateAlbums: [],
      currentSlide: 0,
      currentImgElem: 0,
      max_img_elems: 2,
      stop_cycle: false,
      current_view: 0,
      current_album: "Slideshow",
      views: {
        "SLIDESHOW": 0,
        "ALBUMS": 1,
        "LOAD": 2,
      },
      chosenAlbum: "",
      prompt: "",
      shuffle_order: {},
      comment: "",
      all_slideshow_albums: {},
      albumCoverPhotos: {},
      photosLoaded: 0,
      loadingScale: 0,
      loading: false,
      albums: [],
      windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      shuffleLoaded: new Set(),
      slideshowInterval: null,
      slideshowTimeouts: {},
      imgWidth: null
    }
  },

  computed: {
    category_albums: function() {
      var albums = this.albums;
      console.log(typeof albums);
      var categories = new Set(albums.map(album => album.category));
      var category_albums = {};
      for (let category of categories.values()) {
        category_albums[category] = albums.filter(album => album.category == category);
      }
      return category_albums;
    }
  },

  beforeCreate: function() {
    var slideshow = "Slideshow"
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
      slideshow = "Slideshow2"
    }
    this.$http.post("https://photography.gproductions.org/API/" + slideshow).then(function(res) {
      this.all_slideshow_albums["Slideshow"] = res.data;
      this.$refs.clickhelper.classList.remove("noOpacity");
      this.startSlideShow();

      this.$http.get("https://photography.gproductions.org/API/albums").then(function(res) {
        console.log(res);
        this.albums = res.data;
        this.getCoverPhotos();
      });

    });
  },

  created() {
    window.addEventListener('resize', function () { this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth });

    if (this.isMobile) {
      this.imgWidth = Math.floor(this.windowWidth * 1.55);
    } else {
      this.imgWidth = Math.floor(this.windowWidth * 1.25);
    }
  },

  mounted() {
    this.$root.$on(this.pageMessages[this.thisPage][0], this.scrolledTo);
    this.$root.$on(this.pageMessages[this.thisPage][1], this.scrolledAway);
  },
  methods: {
    sleep(milliseconds) {
      return new Promise(function(resolve, reject) {
        setTimeout(resolve, milliseconds, true);
      });
    },

    noPropogation(e) {
      e.stopPropagation();
    },
    
    scrolledTo() {
      console.log("SCROLLED TO");
      this.stop_cycle = false;
      this.startSlideShow();
      this.$refs.photo_body.classList.remove("noShow");
    },
    scrolledAway() {
      console.log("SCROLLED AWAY");
      this.stop_cycle = true;
      clearInterval(this.slideshowInterval);
      this.$refs.photo_body.classList.add("noShow");
    },
    getCoverPhotos() {
      for (let album of this.albums) {
        this.albumCoverPhotos[album.id] = {coverPhoto: album.coverphoto}
        let image = new Image;
        image.onload = this.coverPhotoGood(album.id);
        image.src =album.coverphoto.url + '=w' + Math.floor(this.windowWidth);
      }
    },

    coverPhotoGood(album) {
      this.albumCoverPhotos[album].coverPhotoGood = true;
    },

    shuffle(array) {
      return array.sort(() => Math.random() - 0.5);
    },

    startSlideShow: async function() {
      // this.$refs.collectionBtn.classList.remove("gnCollection");
      // await this.sleep(350);

      this.$refs.slide0.className = "img noShow shadow-lg slideshow_img";
      this.$refs.slide1.className = "img noShow shadow-lg slideshow_img";
      this.currentSlide = 0;
      this.currentImgElem = 0;
      this.comment = "";

      for (let album in this.all_slideshow_albums) {
        this.shuffle_order[album] = this.shuffle([...Array(this.all_slideshow_albums[album].photos.length).keys()]);
      }

      let img1 = new Image;
      img1.shuffle_index = this.shuffle_order[this.current_album].shift()
      img1.onload = function() {
        document.getElementById("slide0").src = this.src;
        document.getElementById("slide0").classList.remove("noShow");
      }
      this.shuffleLoaded.add(img1.shuffle_index);
      let photo = this.all_slideshow_albums[this.current_album].photos[img1.shuffle_index];
      img1.src = photo.url + "=w" + this.imgWidth;

      let img2 = new Image;
      img2.shuffle_index = this.shuffle_order[this.current_album][0]
      img2.onload = function() {
        this.shuffleLoaded.add(img2.shuffle_index);
      }.bind(this)
      photo = this.all_slideshow_albums[this.current_album].photos[img2.shuffle_index];
      console.log(photo);
      img2.src = photo.url + "=w" + this.imgWidth;
      this.slideshowInterval = setInterval(this.cycleSlideshow, 5000);
    },

    cycleSlideshow: async function() {

      try {
        if (this.stop_cycle) {
          clearInterval(this.slideshowInterval);
          return;
        }

        if (!this.shuffleLoaded.has(this.shuffle_order[this.current_album][0])) {
          return;
        }

        let oldImgElem = this.currentImgElem;
      
        this.currentImgElem++;
        console.log("IMG2: " + this.currentImgElem + ", STOP: " + this.stop_cycle);
        if (this.currentImgElem >= this.max_img_elems) {
          this.currentImgElem = 0;
        }

        let animation_num = Math.floor((Math.random() * 6) + 1);
        if (!this.isMobile) {
          this.$refs["slide" + this.currentImgElem].classList.add("transitionNone", "animate" + animation_num + "_1");
        }
        let photo = this.all_slideshow_albums[this.current_album].photos[this.shuffle_order[this.current_album].shift()];
        this.$refs["slide" + this.currentImgElem].src = photo.url + "=w" + this.imgWidth;
        await this.sleep(50);
        this.$refs["slide" + this.currentImgElem].classList.remove("transitionNone", "noShow");
        if (!this.isMobile) {
          this.$refs["slide" + this.currentImgElem].classList.add("animate" + animation_num + "_2");
        }
        this.$refs["slide" + oldImgElem].classList.add("noShow");
        this.comment = "";
        await this.sleep(1500);
        
        if (photo.description) {
          this.comment = photo.description;
        }

        this.$refs["slide" + oldImgElem].className = "img shadow-lg slideshow_img noShow";
      
        let the_image = new Image;
        the_image.shuffle_index = this.shuffle_order[this.current_album][0];
        the_image.onload = function() {
          this.shuffleLoaded.add(the_image.shuffle_index);
        }.bind(this)
        photo = this.all_slideshow_albums[this.current_album].photos[the_image.shuffle_index];
        if (!photo) {
          this.shuffle_order[this.current_album] = this.shuffle([...Array(this.all_slideshow_albums[this.current_album].photos.length).keys()]);
          this.shuffleLoaded = new Set();
          photo = this.all_slideshow_albums[this.current_album].photos[this.shuffle_order[this.current_album][0]];
        } 
        the_image.src = photo.url + "=w" + this.imgWidth;
      }
      catch (err) {
        if (!this.stop_cycle) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
      }
      
    },

    switchToSelectAlbumMode: async function() {
      this.stop_cycle = true;
      clearInterval(this.slideshowInterval);
      // this.$refs.collectionBtn.classList.add("gnCollection");
      this.current_view = this.views["ALBUMS"];
      await this.sleep(100);
      this.$refs.returnBtn.classList.remove("gnCollection");
    },

    switchToHome: async function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.stop_cycle = false;
      this.$refs.returnBtn.classList.add("gnCollection");
      this.current_view = this.views["SLIDESHOW"];
      this.startSlideShow();
      await this.sleep(1500);
      this.$refs.clickhelper.classList.remove("noOpacity");
      // this.$refs.collectionBtn.classList.remove("gnCollection");
      
    },

    switchMode() {
      if (this.current_view == this.views["SLIDESHOW"]) {
        this.switchToSelectAlbumMode();
      }
    },

    showCoverPhotoDebounce(e, album) {
      this.slideshowTimeouts[album] = setTimeout(this.showCoverPhoto, 900, e, album);
    },

    showCoverPhoto: async function(e, album) {
      if (!(album in this.slideshowTimeouts)) {
        return;
      }

      console.log(e);
      console.log(album);
      let elem = e.target;
      // elem.classList.add("highlight");
      // this.$refs.albums_container.classList.add("dull");
      let img_elem = 0;
      if (this.currentImgElem == 0) {
        img_elem = 1;
      }
      let photo = this.albumCoverPhotos[album].coverPhoto;
      if (this.$refs["slide" + img_elem].src.indexOf(photo.url) != -1) {
        this.$refs["slide" + img_elem].classList.remove("selectAlbumBackground", "noShow");
        return;
      }
      // this.$refs["slide" + this.currentImgElem].style.setProperty("transition", "0.5s !important");
      this.$refs["slide" + img_elem].classList.add("selectAlbumBackground", "noShow");
      await this.sleep(500);
      this.$refs["slide" + img_elem].src = photo.url + '=w' + Math.floor(this.windowWidth);
      this.$refs["slide" + img_elem].classList.remove("selectAlbumBackground", "noShow");
      this.$refs["slide" + this.currentImgElem].classList.remove("visible", "selectAlbumBackground");
    },

    hideCoverPhoto: async function() {
      let img_elem = 0;
      if (this.currentImgElem == 0) {
        img_elem = 1;
      }
      await this.sleep(300);
      this.$refs["slide" + this.currentImgElem].classList.add("visible", "selectAlbumBackground");
      await this.sleep(500);
      this.$refs["slide" + img_elem].classList.add("selectAlbumBackground", "noShow");
      // await this.sleep(550);
    },

    darkenCoverPhoto(e, album) {
      clearInterval(this.slideshowTimeouts[album]);
      delete this.slideshowTimeouts[album];
      let elem = e.target;
      let img_elem = 0;
      if (this.currentImgElem == 0) {
        img_elem = 1;
      }
      this.$refs["slide" + img_elem].classList.add("selectAlbumBackground");
      // this.$refs.albums_container.classList.remove("dull");
      // elem.classList.remove("highlight");
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face { font-family: helvetica_neue; src: url('/fonts/HelveticaNeue.ttf'); }
@font-face { font-family: helvetica_neue2; src: url('../assets/fonts/HelveticaNeue.ttf'); }
@font-face { font-family: goth; src: url('../assets/fonts/chubgothic_1.ttf'); }
@font-face { font-family: babas; src: url('../assets/fonts/BebasNeue.otf'); }
@font-face { font-family: robotBold; src: url('../assets/fonts/Roboto-BoldCondensed.ttf'); }
@font-face { font-family: codec_warm; src: url('../assets/fonts/Codec-Warm-Thin-trial.ttf'); }
@font-face { font-family: codec_cold; src: url('../assets/fonts/Codec-Cold-News-trial.ttf'); }
@font-face { font-family: robot; src: url('../assets/fonts/Roboto-Light.ttf'); }

@keyframes fadeEffect {
	from {opacity: 0;}
	to {opacity: 1 !important;}
}

.noOpacity {
  opacity: 0;
}

.body {
  /* background: white; */
  height: 100vh;
  overflow: hidden;
  position: relative;
  padding-bottom: 4vh;
  transition: opacity 0.7s;
}

.clickhelper_container {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  cursor: default;
}

.clickhelper {
  position: relative;
  margin: auto;
  /* margin-right: 1rem; */
  /* margin-top: 2rem; */
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  font-family: helvetica_neue, helvetica_neue2;
  letter-spacing: 1px;
  color: white;
  cursor: default;
  top: 49%;
  transition: 1.5s ease;
  text-shadow: 0 0 1rem black;
}

#collectionBtn {
	position: absolute;
  top: 1%;
  right: 1%;
  width: 20vh;
  height: 5vh;
  border-radius: 1rem;
  background: rgb(255, 255, 255, 0.25);
  font-size: 1rem;
  color: white;
  /* box-shadow: 0.1rem 0.1rem 1rem rgba(0, 0, 0, 0.5); */
  display: inline-flex;
  justify-content: center;
  transition: 0.3s ease;
  cursor: pointer;
}

#collectionBtn:hover {
  background: rgb(0, 0, 0, 0.25) !important; 
}

#returnBtn {
  position: absolute;
  top: 1vw;
  right: 1vw;
  transform: translateX(-50%);
  width: 4vh;
  height: 4vh;
  border-radius: 50%;
  background: rgb(255, 255, 255, 0.25);
  font-size: 1rem;
  color: white;
  /* box-shadow: 0.1rem 0.1rem 1rem rgb(0 0 0 / 50%); */
  display: inline-flex;
  /* display: flex; */
  /* justify-content: center; */
  transition: 0.3s ease;
  cursor: pointer;
  /* padding-right: 1.3rem; */
  /* padding-left: 0.8rem; */
  box-shadow: 0 0 0.8rem rgb(0 0 0 / 10%);
}

#returnBtn:hover {
  background: rgb(0, 0, 0, 0.25) !important; 
}

.gnCollection {
	transform: translateY(15%);
	opacity: 0;
}

#collectionSVG, #returnBtnSVG {
	display: block;
  height: 0.7rem;
  margin: auto;
  /* margin-right: 0; */
  opacity: 0.7;
  filter: invert(1);
}

#collectionText, #returnBtnText {
  font-family: system-ui;
  font-size: 0.5rem;
  vertical-align: middle;
  margin: auto;
  margin-left: 0;
  cursor: inherit;
}

#comment {
  border-radius: 2px;
  position: absolute;
  left: 0;
  width: 25vw;
  text-align: center;
  color: white;
  vertical-align: middle;
  bottom: 6vh;
  height: 6vh;
  font-family: unset;
  font-size: 1rem;
  transition: 1s;
  text-shadow: 0rem 0rem 0.2rem rgba(0,0,0,1.0)!important;
}

.visible {
  opacity: 1 !important;
  /* transform: unset !important; */
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-10px);
  opacity: 0;
}

.transitionNone {
  transition: all 0ms !important;
}

.animate1_1 {
  transform: translateY(0%);
}

.animate1_2 {
  transform: translateY(-15%);
}

.animate2_1 {
  transform: translateY(-15%);
}

.animate2_2 {
  transform: translateY(0%);
}

.animate3_1 {
  transform: scale(1.0);
}

.animate3_2 {
  transform: scale(1.1);
}

.animate4_1 {
  transform: scale(1.1);
}

.animate4_2 {
  transform: scale(1.0);
}

.animate5_1 {
  transform: translateX(-5%);
}

.animate5_2 {
  transform: translateX(1%);
}

.animate6_1 {
  transform: translateX(1%);
}

.animate6_2 {
  transform: translateX(-3%);
}

.fade2-enter-active, .fade2-leave-active {
  transition: opacity 2s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade2-enter-active, .fade2-leave-active {
  transition: opacity 2s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.overflowY {
  overflow: scroll !important;
}

.noOverflow {
  overflow: hidden !important;
}

.slideshow {
  width: 105vw;
  min-height: 100vh;
  position: relative;
  top: 0vh;
  overflow: hidden;
  background: #111111;
  transition: 0.1s;
}

.slideshow_img {
  position: absolute;
  width: 105% !important;
  top: 0%;
  height: auto;
  min-height: 100vh;
  border-radius: 0px !important;
  transition: transform 15s, opacity 1.5s, filter 0.5s;
  transition-timing-function: linear !important;
  background: transparent !important;
}

.noShow {
  opacity: 0;
}

.noShowFast {
  opacity: 0 !important;
  transition: transform 15s, opacity 0.5s !important;
}

.noShowFastest {
  opacity: 0 !important;
  transition: transform 15s, opacity 0.14s !important;
}

.img{
    width: inherit;
    /* height: inherit; */
    border-radius: 0px;
    flex-shrink: 0;
}

.selectAlbumBackground {
  filter: blur(10px) brightness(0.7)
}

#albums_container {
  color: white;
  position: relative;
  /* text-shadow: 1px 1px 2px rgb(0 0 0 / 60%); */
  letter-spacing: 6px;
  top: 20%;
  font-family: helvetica_neue, helvetica_neue2;
}

.category {
  /* color: white; */
  color: inherit;
  margin-top: 1rem;
  margin-bottom: 2rem;
  height: auto;
  max-height: 2.3rem;
  transition: 1s ease;
  position: relative;
  overflow: hidden;
  transition-delay: 0.5s;
  display: grid;
  pointer-events: none;
}

.category:hover {
  max-height: 11rem;
  transition-delay: 0s;
}

.category:hover .categoryTxt {
  color: white;
}

.category:hover li {
  opacity: 1;
  transition-delay: 0.3s;
}

.categoryTxt {
  color: lightgray;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  cursor: default;
  pointer-events: auto;
  width: fit-content;
  transition: 0.5s ease;
  margin: auto;
  margin-bottom: 1rem;
}

.albums_list {
  color: inherit;
  list-style: none;
  width: auto;
  padding-inline-start: 0;
  display: inline-flex;
  margin-block-start: 0;
  transition: 1s;
  margin-block-end: 0;
  position: relative;
  letter-spacing: unset;
  max-width: 90vw;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
  pointer-events: auto;
}

li {
  color: inherit;
  margin: auto;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  padding: 1rem;
  opacity: 0;
  transition: all 0.5s;
  cursor: pointer;
  letter-spacing: 1.7px;
  background: rgba(255,255,255,0);
  border-radius: 0.5rem;
}

li:hover {
  background: rgba(255,255,255,0.1);
  text-shadow: 0 0 0.3rem black;
}

.fastTransition {
  transition: opacity 0.2s ease, filter 0.6s ease, all 0.4s ease;
}

.highlight {
  color: white;
}

.dull {
  color: rgba(255,255,255,0.4) !important;
}

a {
  color: inherit;
  transition: 0.1s;
  text-decoration: none !important;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

a:focus {
  color: inherit;
  outline: none;
}

@media (min-width: 1440px) { 
  #albums_container {
    color: white;
    position: relative;
    /* text-shadow: 1px 1px 2px rgb(0 0 0 / 60%); */
    letter-spacing: 6px;
    top: 20%;
    font-family: helvetica_neue, helvetica_neue2;
  }
}

@media (max-width:481px) {
  #collectionBtn {
    top: unset !important;
    bottom: 2% !important;
    right: 2% !important;
    width: 10vh !important;
    height: 10vh !important;
  }

  #returnBtn {
    top: unset !important;
    bottom: 3% !important;
    right: unset !important;
    left: 50% !important;
    width: 10vh !important;
    height: 10vh !important;
  }

  .slideshow_img {
    position: absolute;
    /* width: 105% !important; */
    top: 0%;
    height: auto;
    min-height: 100vh;
    border-radius: 0px !important;
    transition: transform 15s, opacity 1.5s, filter 0.5s;
    transition-timing-function: linear !important;
    background: transparent !important;
    width: auto !important;
    height: auto !important;
    left: 50% !important;
    min-width: 100% !important;
    transform: translateX(-50%) !important;
  }

  .category:hover {
    height: 7rem !important;
    transition-delay: 0s;
  }

  .albums_list {
    max-width: 90vw !important;
    font-size: 0.8rem !important;
  }

  li {
    padding: 1rem;
  }

  #albums_container {
    top: 10% !important;
  }


}

</style>
